import { myVideosService } from "../../../services/video";
import { VIDEO_ERROR, VIDEO_LIST, VIDEO_LOADING } from "../types";

// export const getVideoAction =
//   ({ id }) =>
//   (dispatch) => {
//     dispatch({ type: VIDEO_LOADING });

//     return listSingleVideoService({ id })
//       .catch((e) =>
//         dispatch({
//           type: VIDEO_ERROR,
//           payload: e,
//         })
//       )
//       .then((d) => {
//         if (d?.error)
//           return dispatch({
//             type: VIDEO_ERROR,
//             payload: d?.error,
//           });

//         dispatch({
//           type: VIDEO_LIST,
//           payload: d,
//         });
//       });
//   };

export const myVideosAction =
  ({ page, limit, text, videoId, categoryId }) =>
  (dispatch) => {
    dispatch({ type: VIDEO_LOADING });

    return myVideosService({ page, limit, text, videoId, categoryId })
      .catch((e) =>
        dispatch({
          type: VIDEO_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        if (d?.error)
          return dispatch({
            type: VIDEO_ERROR,
            payload: d?.error,
          });

        dispatch({
          type: VIDEO_LIST,
          payload: d,
        });
      });
  };
